import { Button } from '@eureca/ui';

function CheckIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      className="h-6 w-6 text-secondary-foreground"
      aria-hidden="true"
    >
      <path d="M20 6 9 17 4 12" />
    </svg>
  );
}

type AccessRequestedFeedbackProps = {
  /**
   * Back-to-login action. Defaults to a FULL page load of `/login` — this
   * screen renders BEFORE the router mounts (see KeycloakGate / spec 022
   * Decision 3), so TanStack navigation is unavailable, and the module-level
   * `accessDeniedDetected` flag in KeycloakGate only resets on a real reload.
   */
  onBack?: () => void;
};

export function AccessRequestedFeedback({ onBack }: AccessRequestedFeedbackProps) {
  const handleBack =
    onBack ??
    (() => {
      window.location.assign('/login');
    });

  return (
    <div className="flex min-h-dvh items-center justify-center bg-background px-16 py-20">
      <div className="flex w-full max-w-[640px] flex-col items-center gap-5 text-center">
        <div
          aria-hidden="true"
          className="flex h-16 w-16 shrink-0 items-center justify-center rounded-full bg-secondary"
        >
          <CheckIcon />
        </div>

        <div className="flex w-full flex-col gap-[10px]">
          <h1 className="text-5xl font-semibold leading-none tracking-tight text-foreground">
            Acesso solicitado
          </h1>
          <p className="text-base leading-6 text-accent-foreground">
            Se a solicitação for aprovada, você recebe um e-mail em até 3 dias úteis. Se não receber
            nada nesse prazo, o acesso não foi liberado desta vez.
          </p>
        </div>

        <Button
          type="button"
          variant="outline"
          data-testid="access-requested-back"
          onClick={handleBack}
        >
          Voltar para o login
        </Button>
      </div>
    </div>
  );
}
